/**
 * The availability of content by countries
 * @module services/content-policy/availability
 */

/**
 * The countries in the policy are allowed to access
 */
export const CONTENT_POLICY_AVAILABILITY_ONLY_IN = 1

/**
 * The countries in the policy are blocked from access
 */
export const CONTENT_POLICY_AVAILABILITY_BLOCKED_IN = 2

/**
 * No country restriction
 */
export const CONTENT_POLICY_AVAILABILITY_WORLDWIDE = 3

/**
 * Get all of the valid availability values
 */
export function getAvailabilityOptions () {
  return [
    { label: 'Only In', value: CONTENT_POLICY_AVAILABILITY_ONLY_IN },
    { label: 'Blocked In', value: CONTENT_POLICY_AVAILABILITY_BLOCKED_IN },
    { label: 'Worldwide', value: CONTENT_POLICY_AVAILABILITY_WORLDWIDE },
  ]
}
